module.exports = __webpack_public_path__ + "static/5-db8856499ab7e6c23349e72b26035daa.png";